export const sharedColors = {
  border: '1px solid #e1e8ed',
  darkGreyText: '#14171a',
  medGreyText: '#657786',
  momentBorder: '1px solid #f0f3f4',
}
